export const LOAD_FACILITY_SUBLIMITS_STARTED = 'LOAD_FACILITY_SUBLIMITS_STARTED';
export const LOAD_FACILITY_SUBLIMITS_SUCCEEDED = 'LOAD_FACILITY_SUBLIMITS_SUCCEEDED';
export const LOAD_FACILITY_SUBLIMITS_FAILED = 'LOAD_FACILITY_SUBLIMITS_FAILED';

export const SAVE_FACILITY_SUBLIMIT_STARTED = 'SAVE_FACILITY_SUBLIMIT_STARTED';
export const SAVE_FACILITY_SUBLIMIT_SUCCEEDED = 'SAVE_FACILITY_SUBLIMIT_SUCCEEDED';
export const SAVE_FACILITY_SUBLIMIT_FAILED = 'SAVE_FACILITY_SUBLIMIT_FAILED';

export const DELETE_FACILITY_SUBLIMIT_STARTED = 'SAVE_FACILITY_SUBLIMITS_STARTED';
export const DELETE_FACILITY_SUBLIMIT_SUCCEEDED = 'SAVE_FACILITY_SUBLIMITS_SUCCEEDED';
export const DELETE_FACILITY_SUBLIMIT_FAILED = 'SAVE_FACILITY_SUBLIMITS_FAILED';

export const LOAD_FACILITY_SUBLIMIT_FILTERS_STARTED = 'LOAD_FACILITY_SUBLIMIT_FILTERS_STARTED';
export const LOAD_FACILITY_SUBLIMIT_FILTERS_SUCCEEDED = 'LOAD_FACILITY_SUBLIMIT_FILTERS_SUCCEEDED';
export const LOAD_FACILITY_SUBLIMIT_FILTERS_FAILED = 'LOAD_FACILITY_SUBLIMIT_FILTERS_FAILED';

export const UPDATE_FACILITY_SUBLIMIT_FILTERS_STARTED = 'UPDATE_FACILITY_SUBLIMIT_FILTERS_STARTED';
export const UPDATE_FACILITY_SUBLIMIT_FILTERS_SUCCEEDED = 'UPDATE_FACILITY_SUBLIMIT_FILTERS_SUCCEEDED';
export const UPDATE_FACILITY_SUBLIMIT_FILTERS_FAILED = 'UPDATE_FACILITY_SUBLIMIT_FILTERS_FAILED';

export const LOAD_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_STARTED = 'LOAD_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_STARTED';
export const LOAD_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_SUCCEEDED = 'LOAD_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_SUCCEEDED';
export const LOAD_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_FAILED = 'LOAD_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_FAILED';

export const UPDATE_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_STARTED = 'UPDATE_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_STARTED';
export const UPDATE_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_SUCCEEDED =
  'UPDATE_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_SUCCEEDED';
export const UPDATE_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_FAILED = 'UPDATE_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_FAILED';
